import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  tabs: {
    position: "sticky",
    top: "-40px",
    left: "0px",
    minHeight: "40px",
    backgroundColor: "#fff",
    boxShadow: "0 3px 6px -3px rgba(0, 0, 0, 0.2)",
    zIndex: 1,
    "& .MuiTabs-indicator": {
      backgroundColor: theme.palette.secondary.dark
    },
    "& .MuiTabs-root": {
      minHeight: 40
    },
    [theme.breakpoints.down("xs")]: {
      "& .MuiTabs-flexContainer": {
        justifyContent: "space-between"
      },
      "& $tab": {
        minWidth: "initial",
        flex: "auto"
      }
    },
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
      "& > *": {
        flex: "initial"
      }
    }
  },
  tab: {
    minWidth: "100px",
    minHeight: "40px",
    padding: "6px 20px",
    color: theme.palette.text.secondary,
    "&.Mui-selected": {
      color: theme.palette.secondary.dark
    }
  },
  tabUpdated: {
    "&:after": {
      content: '""',
      display: "block",
      width: 5,
      height: 5,
      borderRadius: "50%",
      backgroundColor: "#d0021b",
      position: "absolute",
      right: -8,
      top: 1
    }
  },
  wrapper: {
    lineHeight: 1,
    position: "relative",
    width: "initial"
  }
}));
